<!-- tostring : {{dateTest}} <br>
random : {{dateTest2}}  -->
<div class="centerTxt txtBlkShadow">
  <div class="inline ma5">
    <div class="zodiacMainIcon iconBlkGlow BOS">{{ currentIcon }}</div>
  </div>

  <div class="inline ma5">
    <p class="BOS sunsize">N</p>

    <p>The sun is currently in: </p>
    <p class="monthName">{{ currentSignName }}</p>
    <div class="BOS inline">
      {{ currentElement }}
      {{ currentQuality }}
      {{ currentGlyph }}
      {{ currentHouse }}
      {{ currentPlanet }}
    </div>
    <p>{{ currentShortDescription }}</p>
    <button (click)="changeViewMode()" class="button buttonTxt" [style.background-color]="currentColor ? 'rgb(' + currentColor + ')' : 'unset'" mat-raised-button>{{ currentSignName }} Details</button>
  </div>
</div>


<div class="mobile1-3">
<div class="centerContainer centerTxt">
  
  <div class="inline txtBlkShadow">
    <p>Today is</p>
    <p class="monthName">{{ weekdayIs }} {{ monthIs }} {{ dayIs }}, 2022</p>
  </div>
</div>

<div class="centerContainer centerTxt">
  <div class="inline">
    <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
  </div>

  <div class="inline">
    <button (click)="nextMonth()" mat-raised-button>Next Month</button>
  </div>
</div>
</div>

<div class="mobile4-retina">
<div class="centerContainer centerTxt">
  
  <div class="inline">
    <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
  </div>

  <div class="inline txtBlkShadow">
    <p>Today is</p>
    <p class="monthName">{{ weekdayIs }} {{ monthIs }} {{ dayIs }}, 2022</p>
  </div>

  <div class="inline">
    <button (click)="nextMonth()" mat-raised-button>Next Month</button>
  </div>
</div>
</div>